import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

import type { SelectProps } from "@/react/components/SettingsApp/CompassCompat/Select";
import { Select } from "@/react/components/SettingsApp/CompassCompat/Select";

export interface FormSelectProps extends SelectProps {
  isSearchable?: boolean;
  name: string;
  rules?: RegisterOptions;
}

export const FormSelect = ({
  name,
  rules,
  ...passThroughProps
}: FormSelectProps) => {
  const { control, trigger } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <Select
          {...passThroughProps}
          error={fieldState.error?.message}
          invalid={Boolean(fieldState.error)}
          name={field.name}
          onChange={({ value }) => {
            field.onChange(value);
            if (fieldState.error) void trigger(field.name);
          }}
          value={field.value}
        />
      )}
    />
  );
};

FormSelect.displayName = "Form.Select";
